module.exports = __webpack_public_path__ + "img/oneList4.548324f0.png";